<div class="footer__legals js-accordionContainer  footernav__block--desktop d-lg">
  <div class="footer__legalsTitle" i18n="@@FOOTER.LEGAL_INFORMATIONS">Privacy Policy</div>
  <div class="footer__legalsList js-accordionContent">
    <ng-container *ngTemplateOutlet="accessibilityStatement"></ng-container>
    <ng-container *ngTemplateOutlet="legalLink"></ng-container>
  </div>
</div>

<vc-accordion class="footer__legals footer__block--mobile d-lg-none">
  <ng-container *ngTemplateOutlet="accessibilityStatement"></ng-container>
  <vc-accordion-group
    [index]="1"
    (change)="toggleAccordionClass($event)"
    [class.open]="modifierClass === 1"
    [isOpen]="false"
  >
    <div class="accordion__title footer__legalsTitle" i18n="@@FOOTER.LEGAL_INFORMATIONS">Privacy Policy</div>
    <div class="accordion__content footer__legalsList">
      <ng-container *ngTemplateOutlet="legalLink"></ng-container>
    </div>
  </vc-accordion-group>
</vc-accordion>

<!-- ACCESSIBILITY STATEMENT TEMPLATE --->
<ng-template #accessibilityStatement>
  <vc-ref
    *ngIf="showAccessibilityLink"
    [resource]="accessibilityStatementLink"
    anchor="true"
    class="footer__legalsLink footer__legalsLink--accessibility"
    i18n="@@FOOTER.LEGALS.ACCESSIBILITY_STATEMENT"
  >
    accessibility statement
  </vc-ref>
</ng-template>

<!-- LEGAL LINK TEMPLATE --->
<ng-template #legalLink>
  <ng-container *ngFor="let legal of legals">
    <vc-ref
      *ngIf="isDisplayed(legal) && legal.name !== '$HIDE$'"
      [resource]="legal.link"
      [anchor]="isAnchor(legal)"
      class="footer__legalsLink"
      [blank]="legal.target === '__blank'"
    >
      {{ legal.name }}
    </vc-ref>
  </ng-container>
</ng-template>
